import { Ic } from '../../components/Ic';
import { dateTime } from '../../lib/time';
import type { RaffleRecord } from '../../api/types';

/** Replica of what send_raffles.send_notification() actually posts, rather than
 *  the prototype's placeholder fields. Field order, labels and the 0x2A6C91
 *  accent all mirror the Python so this preview stays truthful. */
const EMBED_COLOR = '#2A6C91';

export function DiscordEmbed({ raffle }: { raffle: RaffleRecord }) {
  const methods = raffle.collection_methods?.join(', ') || 'N/A';

  return (
    <div className="dc-embed" style={{ borderLeftColor: EMBED_COLOR }}>
      <div className="dc-author">
        <Ic.zap style={{ width: 14, height: 14 }} />
        {raffle.site ?? 'Flux Raffles'}
      </div>
      <div className="dc-title">{raffle.site ?? 'Unknown'} - New raffle</div>

      <div className="dc-fields">
        <div style={{ gridColumn: '1 / -1' }}>
          <div className="dc-fk">Name</div>
          <div className="dc-fv">
            {raffle.link ? (
              <a href={raffle.link} target="_blank" rel="noreferrer noopener" style={{ color: '#00a8fc' }}>
                {raffle.product ?? raffle.link}
              </a>
            ) : (
              (raffle.product ?? '—')
            )}
          </div>
        </div>
        <div>
          <div className="dc-fk">Shipping</div>
          <div className="dc-fv">{methods}</div>
        </div>
        <div>
          <div className="dc-fk">Price</div>
          <div className="dc-fv">${raffle.price ?? 'N/A'}</div>
        </div>
        <div style={{ gridColumn: '1 / -1' }}>
          <div className="dc-fk">Registration Closes</div>
          <div className="dc-fv">{raffle.cutoff ? dateTime(raffle.cutoff) : 'N/A'}</div>
        </div>
      </div>

      <div className="dc-foot">
        {raffle.site ?? 'Flux'} | Raffles
        {raffle.scraper ? ` · via ${raffle.scraper}` : ''} · {dateTime(raffle.detected_at)}
      </div>
    </div>
  );
}
